
/**
 * Global Search Panels Class
 */
export class SearchPanels {

	/**
	 * Constructor
	 *
	 * @param {node} container
	 * @return {void}
	 */
	constructor( container ) {

		this.searchContainer = document.querySelector( container );
		if ( ! this.searchContainer ) {

			return false;

		}

		this.addEvents();

	}

	/**
	 * Add Events
	 *
	 * @return {void}
	 */
	addEvents() {

		const queryString = window.location.search;
		const urlParams = new URLSearchParams( queryString );
		const searchPhraseUn = urlParams.get( 'sp' );

		window.addEventListener( 'load', () => {

			/**
			 * Page Loaded
			 *
			 * @return {void}
			 */
			const pageLoaded = () => {

				document.body.classList.add( 'page-loaded' );

			}

			setTimeout( pageLoaded, 750 );

			if ( searchPhraseUn && searchPhraseUn.length > 0 ) {

				const searchPhrase = searchPhraseUn.toString().toLowerCase();

				// Search in blocks
				const parkingSystems = document.querySelectorAll( '.block-parking-systems' );
				const mainFunctionalities = document.querySelectorAll( '.block-main-functionalities' );
				const mainValues = document.querySelectorAll( '.block-main-values' );
				const mainTabs = document.querySelectorAll( '.block-tabs' );
				const tailoredSolutions = document.querySelectorAll( '.block-tailored-solutions' );

				if ( parkingSystems.length > 0 ) {

					parkingSystems.forEach( ( item ) => {

						const tab = item.querySelectorAll( '.block-parking-systems__tab' );
						const button = item.querySelectorAll( '.block-parking-systems__card' );

						if ( tab.length > 0 ) {

							for ( let a = 0; a < tab.length; a++ ) {

								const str = tab[ a ].innerHTML.toString().toLowerCase();

								if ( str.indexOf( searchPhrase ) > 0 ) {

									button[ a ].click();
									break;

								}

							}

						}

					} )

				}

				if ( mainFunctionalities.length > 0 ) {

					mainFunctionalities.forEach( ( item ) => {

						const tab = item.querySelectorAll( '.block-main-functionalities__tab' );
						const button = item.querySelectorAll( '.js-tab-menu-button' );

						if ( tab.length > 0 ) {

							for ( let a = 0; a < tab.length; a++ ) {

								const str = tab[ a ].innerHTML.toString().toLowerCase();

								if ( str.indexOf( searchPhrase ) > 0 ) {

									button[ a ].click();
									break;

								}

							}

						}

					} )

				}

				if ( mainValues.length > 0 ) {

					mainValues.forEach( ( item ) => {

						const tab = item.querySelectorAll( '.js-tabs-item' );
						const button = item.querySelectorAll( '.js-tabs-menu-button' );

						if ( tab.length > 0 ) {

							for ( let a = 0; a < tab.length; a++ ) {

								const str = tab[ a ].innerHTML.toString().toLowerCase();

								if ( str.indexOf( searchPhrase ) > 0 ) {

									button[ a ].click();
									break;

								}

							}

						}

					} )

				}

				if ( mainTabs.length > 0 ) {

					mainTabs.forEach( ( item ) => {

						const tab = item.querySelectorAll( '.block-tabs-item' );
						const button = item.querySelectorAll( '.js-button-tab-nav' );

						if ( tab.length > 0 ) {

							for ( let a = 0; a < tab.length; a++ ) {

								const str = tab[ a ].innerHTML.toString().toLowerCase();

								if ( str.indexOf( searchPhrase ) > 0 ) {

									button[ a ].click();
									break;

								}

							}

						}

					} )

				}

				if ( tailoredSolutions.length > 0 ) {

					tailoredSolutions.forEach( ( item ) => {

						const tab = item.querySelectorAll( '.js-tabs-item' );
						const button = item.querySelectorAll( '.js-tabs-menu-button' );

						if ( tab.length > 0 ) {

							for ( let a = 0; a < tab.length; a++ ) {

								const str = tab[ a ].innerHTML.toString().toLowerCase();

								if ( str.indexOf( searchPhrase ) > 0 ) {

									button[ a ].click();
									break;

								}

							}

						}

					} )

				}

			}

		} );

	}

}
